// Module
var code = "<md-icon ng-if=\"$ctrl.showIndication\" md-svg-icon=\"message\" class=\"bringoz-icon\" ng-click=\"$ctrl.open($ctrl.service, $event)\" aria-label=\"comment\"> </md-icon> ";
// Exports
export default code;